import React from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";

import PageLayout from "../components/Layout/PageLayout";
import PermissionedRoute from "./PermissionedRoute";
import { RegisterVehicles, Manifest, Shipping } from "../views/Deployment";
import Permissions from "../permissions";
import { accessTokenCookieKey, getCookies, refreshTokenCookieKey } from "../API/cookies";

export const DeploymentRouter = () => {
  const location = useLocation();

  if (!getCookies(accessTokenCookieKey) && !getCookies(refreshTokenCookieKey))
    return <Redirect to={{ pathname: "/logout", state: { from: location.pathname } }} />;
  return (
    <Switch>
      <PermissionedRoute
        permission={[Permissions.adminWrite]}
        exact
        path="/deployment/register"
      >
        <PageLayout>
          <RegisterVehicles />
        </PageLayout>
      </PermissionedRoute>
      <PermissionedRoute
        permission={[Permissions.basicWrite]}
        exact
        path="/deployment/manifest"
      >
        <PageLayout>
          <Manifest />
        </PageLayout>
      </PermissionedRoute>
      <PermissionedRoute
        permission={[Permissions.basicWrite]}
        exact
        path="/deployment/shipping"
      >
        <PageLayout>
          <Shipping />
        </PageLayout>
      </PermissionedRoute>
      <Route path="*">
        <Redirect to="/deployment/register" />
      </Route>
    </Switch>
  );
};

export default DeploymentRouter;
